import {RootState} from "../../../../app/store";

export const getResetPasswordState = (state: RootState) => state.resetPassword;